"use strict";
import { TableHeadCell } from "./src/TableHeadCell.dev.js";
import { defineElement } from "@spectrum-web-components/base/src/define-element.js";
defineElement("sp-table-head-cell", TableHeadCell);
//# sourceMappingURL=sp-table-head-cell.dev.js.map
